<template>
  <div class="home-page" :class="theme">
    <!-- Navigation Menu -->
    <nav class="menu">
      <button
        v-for="view in views"
        :key="view.value"
        @click="selectView(view.value)"
        :class="{ active: selectedView === view.value }"
      >
        {{ view.text }}
      </button>
    </nav>

    <div class="view-container" :key="selectedView">
      <!-- Vue détail projet -->
      <div v-if="selectedView === 'projects' && selectedProject" :key="selectedProject.id">
        <h2>{{ selectedProject.projet }}</h2>
        <p><strong>Réalisateur :</strong> {{ selectedProject.realisat }}</p>
        <p><strong>Production :</strong>
          <span v-if="selectedProject.prod && selectedProject.prod2">
            {{ selectedProject.prod }} & {{ selectedProject.prod2 }}
          </span>
          <span v-else>{{ selectedProject.prod || '' }}</span>
        </p>
        <p><strong>Année :</strong> {{ selectedProject.date }}</p>
        <button @click="selectedProject = null">Retour</button>
      </div>

      <!-- Vue principale -->
      <template v-else>
        <ProjectGrid
          v-if="selectedView === 'projects'"
          :key="projectGridKey"
          :filteredProjects="filteredProjects"
          :formatOptions="formatOptions"
          :theme="theme"
        />
        <VFXGrid v-else-if="selectedView === 'vfx'" :theme="theme" />
        <ContactModule v-else-if="selectedView === 'contact'" :theme="theme" />
      </template>
    </div>
  </div>
</template>

<script>
import ProjectGrid from "./ProjectGrid.vue";
import VFXGrid from "./VFXGrid.vue";
import ContactModule from "./ContactModule.vue";

export default {
  props: {
    theme: {
      type: String,
      required: true,
    },
  },
  components: {
    ProjectGrid,
    VFXGrid,
    ContactModule,
  },
  data() {
    return {
      selectedView: localStorage.getItem("selectedView") || "projects",
      projectGridKey: 0,
      projectsLoaded: false,
      selectedProject: null,
      allProjects: [],
      views: [
        { value: "projects", text: "Étalonnage" },
        { value: "vfx", text: "Effets Visuels" },
        { value: "contact", text: "Contact" },
      ],
      filteredProjects: [],
      formatOptions: [
        { value: null, text: "Tous" },
        { value: "music", text: "Musique" },
        { value: "doc", text: "Documentaire" },
        { value: "fiction", text: "Fiction" },
        { value: "art", text: "Art" },
      ],
    };
  },
  methods: {
    selectView(view) {
      this.selectedView = view;
      this.selectedProject = null;
      localStorage.setItem("selectedView", view);

      if (window.location.hash) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      if (view === "projects") {
        this.fetchProjects();
      }
    },

    handleSelectProject(project) {
      this.selectedProject = project;
    },

    resetView() {
      this.selectedView = 'projects';
      this.selectedProject = null;
      localStorage.setItem("selectedView", "projects");
      this.filteredProjects = [];
      this.projectsLoaded = false;
      this.allProjects = [];
      this.fetchProjects();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async fetchProjects() {
      const cached = localStorage.getItem("cachedProjects");
      if (cached) {
        this.allProjects = JSON.parse(cached);
        this.filteredProjects = this.allProjects;
        this.projectsLoaded = true;
        return;
      }

      try {
        const res = await fetch("https://julian-nouveau.com/api.php");
        if (!res.ok) throw new Error("Error fetching projects");
        const data = await res.json();
        this.allProjects = data;
        this.filteredProjects = data;
        localStorage.setItem("cachedProjects", JSON.stringify(data));
        this.projectsLoaded = true;
      } catch (err) {
        console.error(err);
      }
    },
  },

  mounted() {
    if (this.selectedView === "projects") {
      this.fetchProjects();
    }

    window.addEventListener('reset-to-etalonnage', () => {
      this.resetView();
    });
  },
};
</script>

<style scoped>
.menu {
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
}

.menu button {
  font-size: medium;
  border: none;
  border-radius: 0px;
  margin: 0 20px;
  cursor: pointer;
  background-color: transparent;
  color: inherit;
}

.menu button:hover {
  color: rgb(55, 97, 151);
  background-color: rgb(255, 234, 0);
}

.menu button.active {
  text-decoration: underline;
  color: inherit;
  background-color: inherit;
}

.view-container {
  padding: 10px;
}

@media (max-width: 768px) {
  .menu button {
    margin: 0 10px;
  }
  .view-container {
    padding: 0;
  }
}
</style>
